import * as React from 'react';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { IconButton } from '@mui/material';
import SupportIcon from '@mui/icons-material/Support';
import { TriwordStore } from '../TriwordStore';
import { saveTriword, useLetterLifeline } from '../triwordUtils';

// most of this is copied from MUI docs for BasicMenu and then slightly modified

const LifelineButton = () => {
  const solved = TriwordStore.useState(s => s.solved);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const { usedPositionLifeline, usedLetterLifeline, used5050Lifeline } = TriwordStore.useState(s => {
    return {
      usedPositionLifeline: s.usedPositionLifeline,
      usedLetterLifeline: s.usedLetterLifeline,
      used5050Lifeline: s.used5050Lifeline,
    };
  });

  return (
    <span>
      <IconButton
        id="lifelines"
        title="Lifelines"
        disabled={solved}
        onClick={handleClick}
      >
        <SupportIcon/>
      </IconButton>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        <MenuItem disabled={usedPositionLifeline} onClick={() => {
          TriwordStore.update(s => { s.usedPositionLifeline = true; });
          handleClose();
          // timeout so store can update with lifeline usage
          setTimeout(saveTriword, 100);
        }}>Reveal 1 clue position</MenuItem>

        <MenuItem disabled={usedLetterLifeline} onClick={() => {
          TriwordStore.update(s => { s.usedLetterLifeline = true; });
          handleClose();
          useLetterLifeline();
          setTimeout(saveTriword, 100);
        }}>Reveal last letter</MenuItem>

        <MenuItem disabled={used5050Lifeline} onClick={() => {
          TriwordStore.update(s => { s.used5050Lifeline = true; });
          handleClose();
          setTimeout(saveTriword, 100);
        }}>50/50</MenuItem>
      </Menu>
    </span>
  );
};

export default LifelineButton;